import { SCREEN_PRESENTER, UNASSIGNED } from '@studio/constants/Sources';
import { getProgramLayers } from '@studio/program/utils/getProgramLayers';
import removeAttendeeCamera from '@shoflo/studio-redux/actions/attendee/removeAttendeeCamera';
import toggleProgramSource from '@shoflo/studio-redux/actions/program/toggleProgramSource';
import { decreaseScreenShare } from '@shoflo/studio-redux/actions/screenShare/setScreenShare';
import cancelDisconnectSource from '@shoflo/studio-redux/actions/source/cancelDisconnectSource';
import updateSource from 'actions/source/updateSource';
import setProgram from 'actions/program/setProgram';

function removeAttendeeScreen(store, data) {
  const { attendeeId, closedOrReloadTab } = data;
  const { broadcastSources, program } = store.getState();
  const sources = broadcastSources.sources.filter(s =>
    [attendeeId, `${attendeeId}#content`].includes(s.value)
  );

  const layers = getProgramLayers(program);

  if (sources.length) {
    sources.forEach(source => {
      const [layerSource] = layers.filter(
        layer => layer.source._id === source._id
      );
      // Remove if source is in program
      if (!!layerSource) {
        store.dispatch(toggleProgramSource(source, setProgram));
      }
      store.dispatch(updateSource(source._id, { value: UNASSIGNED }));
      store.dispatch(removeAttendeeCamera(source.value));

      if (source.type === SCREEN_PRESENTER) {
        store.dispatch(decreaseScreenShare());
      }
    });

    if (closedOrReloadTab) {
      // We wait for chime to register that the attendee has left the session
      window.setTimeout(() => {
        sources.forEach(source => {
          store.dispatch(cancelDisconnectSource(source._id));
        });
      }, 3000);
    }
  }
}

export default removeAttendeeScreen;
